<opac-dialog [open]="open()" [title]="'general.information' | translate" (closed)="closeDialog()">
  <span class="text">{{ 'user.download.text' | translate }}</span>

  <info-link *ngFor="let link of links()" [link]="link" (experienceLinkSelected)="sendBookClubHistory($event)"> </info-link>

  <ng-container slot="actions">
    <opac-checkbox [ngModel]="checked()" (change)="checked.set($event)">
      {{ 'general.never' | translate }}
    </opac-checkbox>
  </ng-container>
</opac-dialog>
